import PropTypes from "prop-types";
import "../assets/styles/colors.css";

function FullScreenLoader({ message, offsetSidebar = false }) {
  return (
    <div
      className={`fixed inset-0 z-40 flex items-center justify-center${
        offsetSidebar ? " lg:pl-60" : ""
      }`}
    >
      <div className="flex flex-col items-center gap-3 px-6 py-5">
        <svg
          className="h-6 w-6 animate-spin text-(--color-primary)"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
        {message && (
          <p className="text-sm text-(--color-text-white)">{message}</p>
        )}
      </div>
    </div>
  );
}

FullScreenLoader.propTypes = {
  message: PropTypes.string,
  offsetSidebar: PropTypes.bool,
};

export default FullScreenLoader;
